export default __webpack_public_path__ + "static/5_36-2ff04d5419b56ae55664d7671f130a4e.png";